import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { UsersService } from "../../../api";

const MySwal = withReactContent(Swal);

type ToggleUserActiveOptions = {
  firstName?: string | null;
  lastName?: string | null;
  isActive: boolean;
  onSuccess?: () => void;
};

export async function toggleUserActive(id: number, options: ToggleUserActiveOptions) {
  const fullName = `${options.firstName ?? ""} ${options.lastName ?? ""}`.trim() || "this user";
  const activating = options.isActive;

  const result = await MySwal.fire({
    title: <strong>{activating ? "Reactivate user?" : "Deactivate user?"}</strong>,
    html: activating ? (
      <div>
        You are about to reactivate <strong>{fullName}</strong>. They will be able to sign in again.
      </div>
    ) : (
      <div>
        You are about to deactivate <strong>{fullName}</strong>. They will no longer be able to sign in,
        but their data will be kept.
      </div>
    ),
    icon: "question",
    showCancelButton: true,
    cancelButtonText: "Cancel",
    confirmButtonText: activating ? "Yes, reactivate" : "Yes, deactivate",
    confirmButtonColor: activating ? "#1976d2" : "#d32f2f",
    reverseButtons: true,
  });

  if (!result.isConfirmed) {
    return false;
  }

  try {
    await UsersService.postApiUsersSetActive(id, activating);
    await MySwal.fire({
      icon: "success",
      title: <p>{activating ? "User reactivated." : "User deactivated."}</p>,
    });
    options.onSuccess?.();
    return true;
  } catch {
    await MySwal.fire({
      icon: "error",
      title: <p>Could not update user status. Please try again.</p>,
    });
    return false;
  }
}

export function isUserActive(user: { isActive?: boolean | null }) {
  return user.isActive !== false;
}
